// removed by extract-text-webpack-plugin
module.exports = {"apollo":"_1QR11ErbLTLuX4WBpzZ-62","img":"_2-0vggCVauMIQGCZil5ppE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Apollo/Apollo.css
// module id = 169
// module chunks = 0